import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Nav from './navigation'
function Header(){
  const [navbarOpen, setNavbarOpen] = useState(false);
return( <>
    <div className='Header'>
    <div className='ContactButton'><Link to='#'> <img src={require('../images/contact-us.webp')} alt='Contact us'/></Link></div>
        <div className='container'>
          <div className='HeaderBox'>
            <div className='Logo'>Digital Heroes</div>
            <div className='Menu'>
              <ul className='List'>
                <Nav/>
              </ul>
            </div>
            <div className='Contact'></div>   
          </div>
          <div className='MobileHeader'>
          <div className='Logo'>Digital Heroes</div>
          <div className='ToggleButton'>
            <button className="toggle" onClick={() => setNavbarOpen((prev) => !prev)}>{navbarOpen ? '☰' : '☰'}</button>
            <div className={`sidenav${navbarOpen ? ' show' : ''}`}>
            <button className="closebtn" onClick={() => setNavbarOpen((prev) => !prev)}>{navbarOpen ? '×' : '×'}</button>
              <div className='SideBarBox'>
              <ul className='List'>
                <Nav/>
              </ul>
            </div>
            </div>
          </div>
        </div>
        </div>
        <div className='BottomBorder'></div>
    </div>
    </>
    )     
}
export default Header;